import { MemberHttpClient } from 'module/api/member';
import { axiosInstance } from 'api/axios';

export const MemberAPI = new MemberHttpClient(axiosInstance);
